import { ReactElement } from 'react';

import {
   appendTestableComponentAttributes,
   appendTestableCustomAttribute,
   TestableComponentProps,
} from '@dreryk/react-components';

import { StyledBannerImage, StyledBannerLink } from './Banner.styled';
import { BannerSize } from './Banner.types';

type BannerProps = TestableComponentProps & {
   readonly bannerUrl: string;
   readonly targetUrl?: string;
   readonly fallback?: ReactElement;
   readonly onLoad?: VoidFunction;
   readonly onError?: VoidFunction;
   readonly size?: BannerSize;
};

export const Banner = (props: BannerProps): JSX.Element => {
   return (
      <StyledBannerLink
         {...appendTestableComponentAttributes('Banner', props.testId)}
         href={props.targetUrl}
         target={'_blank'}
         $size={props.size ?? 'DEFAULT'}
      >
         <StyledBannerImage
            {...appendTestableCustomAttribute('image', props.testId)}
            src={props.bannerUrl}
            onLoad={props.onLoad}
            onError={props.onError}
         />
      </StyledBannerLink>
   );
};
